























import { Component, Vue } from 'vue-property-decorator';

import Firefly from '@/components/Firefly.vue'; // @ is an alias to /src
import Navbar from '@/components/Navbar.vue'; // @ is an alias to /src
import Slider from '@/components/Slider.vue'; // @ is an alias to /src
import Countdown from '@/components/Countdown.vue'; // @ is an alias to /src
import Attending from '@/components/Attending.vue'; // @ is an alias to /src
import RSVP from '@/components/RSVP.vue'; // @ is an alias to /src
import Registary from '@/components/Registary.vue'; // @ is an alias to /src
import Gallery from '@/components/Gallery.vue'; // @ is an alias to /src
import Thankyou from '@/components/Thankyou.vue'; // @ is an alias to /src
import Music from '@/components/Music.vue'; // @ is an alias to /src
import Copyrights from '@/components/Copyrights.vue'; // @ is an alias to /src
import Location from '@/components/Location.vue'; // @ is an alias to /src

@Component({
  components: {
    Navbar,
    Slider,
    Countdown,
    Attending,
    RSVP,
    Thankyou,
    Music,
    Firefly,
    Copyrights,
    Registary,
    Gallery,
    Location,
  },
})
export default class App extends Vue {
  public personIsAttending = false;
  public userIsAttending(attending: boolean) {
    this.personIsAttending = attending;
  }

  private mounted() {
    const sources = [
      './js/jquery-1.12.4.min.js',
      './js/wedding_library.js',
      './js/library/jquery.plugin.min.js',
      './js/jquery.countdown.min.js',
      './js/wedding_script.js',
    ];

    sources.forEach((source: string) => {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', source);
      document.head.appendChild(recaptchaScript);
    });
  }

  get canRSVP() {
    return this.$route.query.canRSVP !== 'true';
  }
}
